import { Overview } from './Overview'
import { withOverview } from './withOverview'

const Connected = withOverview(Overview)

export { Connected as Overview }
